import * as NortonActions from './../actions/norton.actions';
import { TechnicalError } from '@dch/products-business-logic';

export interface NortonState {
  attributes: any;
  isPendingAttributes: boolean;
  errorAttributes: TechnicalError;
  price: any;
  isPendingPrice: boolean;
  errorPrice: TechnicalError;
  nortonAccount: any;
  isPendingNortonAccount: boolean;
  errorNortonAccount: TechnicalError;
}

export const initialState: NortonState = {
  attributes: null,
  isPendingAttributes: false,
  errorAttributes: null,
  price: [],
  isPendingPrice: false,
  errorPrice: null,
  nortonAccount: null,
  isPendingNortonAccount: false,
  errorNortonAccount: null,
};

export function reducer(
  state: NortonState = initialState,
  action: NortonActions.Actions,
): NortonState {
  switch (action.type) {
    case NortonActions.GET_NORTON_PRODUCTS_ATTRIBUTES:
      return {
        ...state,
        isPendingAttributes: true,
        errorAttributes: null,
      };
    case NortonActions.GET_NORTON_PRODUCTS_ATTRIBUTES_SUCCESS:
      return {
        ...state,
        attributes: action.payload,
        isPendingAttributes: false,
        errorAttributes: null,
      };
    case NortonActions.GET_NORTON_PRODUCTS_ATTRIBUTES_FAILED:
      return {
        ...state,
        attributes: null,
        errorAttributes: action.payload,
        isPendingAttributes: false,
      };
    case NortonActions.GET_NORTON_PRODUCT_PRICE:
      return {
        ...state,
        isPendingPrice: true,
        errorPrice: null,
      };
    case NortonActions.GET_NORTON_PRODUCT_PRICE_SUCCESS:
      return {
        ...state,
        price: action.payload.responses[0],
        isPendingPrice: false,
        errorPrice: null,
      };
    case NortonActions.GET_NORTON_PRODUCT_PRICE_FAILED:
      return {
        ...state,
        price: null,
        errorPrice: action.payload,
        isPendingPrice: false,
      };
    case NortonActions.GET_NORTON_ACCOUNT:
      return {
        ...state,
        isPendingNortonAccount: true,
        errorNortonAccount: null,
      };
    case NortonActions.GET_NORTON_ACCOUNT_SUCCESS:
      return {
        ...state,
        nortonAccount: action.payload,
        isPendingNortonAccount: false,
        errorNortonAccount: null,
      };
    case NortonActions.GET_NORTON_ACCOUNT_FAILED:
      return {
        ...state,
        nortonAccount: null,
        errorNortonAccount: action.payload,
        isPendingNortonAccount: false,
      };
    default:
      return state;
  }
}

export const getProductsAttributes = (state: NortonState) => state.attributes;
export const getProductsAttributesTechnicalError = (state: NortonState) =>
  state.errorAttributes;
export const getProductsAttributesPending = (state: NortonState) =>
  state.isPendingAttributes;

export const getProductsPrice = (state: NortonState) => state.price;
export const getProductsPriceTechnicalError = (state: NortonState) =>
  state.errorPrice;
export const getProductsPricePending = (state: NortonState) =>
  state.isPendingPrice;

export const getNortonAccount = (state: NortonState) => state.nortonAccount;
export const getNortonAccountTechnicalError = (state: NortonState) =>
  state.errorNortonAccount;
export const getNortonAccountPending = (state: NortonState) =>
  state.isPendingNortonAccount;
